import { useState, useCallback } from "react";
import { UseInvestmentModalsReturn } from "./types";

export const useInvestmentModals = (): UseInvestmentModalsReturn => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [activateModal, setActivateModal] = useState(false);

  const openDeleteModal = useCallback(() => setDeleteModal(true), []);
  const closeDeleteModal = useCallback(() => setDeleteModal(false), []);

  const openActivateModal = useCallback(() => setActivateModal(true), []);
  const closeActivateModal = useCallback(() => setActivateModal(false), []);

  return {
    deleteModal,
    activateModal,
    openDeleteModal,
    closeDeleteModal,
    openActivateModal,
    closeActivateModal,
  };
};
